<template>
	<!-- forgot password-->
		  <div class="modal fade" id="forgotModal" tabindex="-1" role="dialog">
			  <div class="modal-dialog">
				  <div class="modal-content dir-rtl">
						  <div class="modal-body ">
							  <button type="button" class="btn-close" data-bs-dismiss="modal" style="display: none;" id="forgotModalCloseBTN"></button>
							  <div v-if="sending == false">
								  <h3 class="agileinfo_sign" style="display:inline-block;text-align:center;font-size:16px;font-weight: 600;margin-bottom: 0;">لطفا تلفن همراهتان را برای ارسال رمز عبور وارد نمایید</h3>
								  <div class="form-group">
								  <input class="form-control dir-rtl mt-3"  v-model="userMobile" type="tel" maxlength="11" placeholder="شماره همراه" style="height: 49px">
									  <span style="color:red">{{validMessage}}</span>
									  <button class="btn btn-primary valid-btn w-100 mt-3"  @click="sendCode">ارسال رمز عبور</button>
								  </div>
							  </div>
							  <div v-else>
								  <h3 class="agileinfo_sign" style="display:inline-block;text-align:center;font-size:16px;font-weight: 600;margin-bottom: 0;">لطفا رمز عبور ارسال شده را وارد نمایید</h3>
								  <div class="form-group">
								  <input class="form-control dir-ltr text-left mt-3" v-model="userPassword" type="text" placeholder="رمز عبور" style="height: 49px">
									  <span style="color:red">{{validMessage}}</span>
									  <button class="btn btn-primary valid-btn w-100 mt-3" @click="entryUser">ورود</button>
								  </div>
							  </div>
					  </div>
				  </div>
			  </div>
		  </div>
</template>
<script setup>
import axios from "axios";
import { ref,watch } from "vue";
import { convertToEnglish, convertToPersian } from "@/composables/digits.js";

let userMobile = ref();
let userPassword = ref();
let validMessage = ref();
let userInfo = ref();
let sending = ref(false);
let code = ref();
watch(userMobile, () => {
  userMobile.value = convertToPersian(userMobile.value);
  console.log(userMobile.value);
});
watch(userPassword, () => {
  userPassword.value = convertToPersian(userPassword.value);
});
function sendCode() {
  if(userMobile.value && parseInt(userMobile.value.length) == 11) {
	  userMobile.value = convertToEnglish(userMobile.value);
    validMessage.value = "";
    const formData = new FormData();
    formData.append('number', userMobile.value);
    axios.post("https://radap.ir/Backend/api/section/follow/forgot.php",formData)
      .then(function (response) {
        if (response.data == "loss") {
          validMessage.value = "شما در سایت ثبت نام نکرده اید، لطفا ابتدا ثبت نام کنید";
          setTimeout(() => {
            validMessage.value = "";
            document.querySelector("#forgotModalCloseBTN").click();
            document.querySelector("#mobileModalBTN").click();
          }, 2000);
        } else {
          sending.value = true;
          code.value = response.data - 876;
        }
      });
  } else {
    validMessage.value = "شماره موبایل اشتباه است";
  }
}
function entryUser() {
	userMobile.value = convertToEnglish(userMobile.value);
	userPassword.value = convertToEnglish(userPassword.value);
  if (code.value == userPassword.value) {
    validMessage.value = "";
    const formData = new FormData();
    formData.append('username', userMobile.value);
    formData.append('password', userPassword.value);

    axios.post("https://radap.ir/Backend/api/section/follow/entry_new.php", formData)
      .then(function (response) {
        if (response.data != "loss") {
          // addLocalStorage(response.data);
          let token = response.data
          localStorage.setItem('token',token)
          location.reload();
        } else {
          validMessage.value = "لطفا ابتدا ثبت نام نمایید";
        }
      });
  } else {
    validMessage.value = "رمز عبور وارد شده صحیح نیست";
  }
}
/*
function addLocalStorage(information) {
  getLocalStorage();
  userInfo.value.push({
    id: information.id,
    name: information.name,
    family: information.family,
    mobile: information.mobile,
    wallet: information.wallet,
    score: information.score,
    location: information.location,

    born: information.born,
    nid: information.nid,
    sheba: information.sheba,
    gender: information.gender,
    email: information.email,

    token: information.token,
  });
  localStorage.setItem("userInfo", JSON.stringify(userInfo.value));
  location.reload();
}
function getLocalStorage() {
  userInfo.value = localStorage.getItem("userInfo");
  userInfo.value = [];
}
*/

</script>

<style>
.modal-body.modal-body-sub_agile {
  padding: 0;
}
</style>
